import React from 'react'
import { ScoreHeader } from 'src/components/page/ratios/score-header'

export const MScore: React.FC = () => {
  return (
    <ScoreHeader
      title={'Earnings Manipulation Risk'}
      score={'M-Score'}
      id={'beneish-m-score-5360'}
    />
  )
}
